import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import FormNuevaCita from "../agenda/FormNuevaCita";
import axios from '../../axios/axiosconf';
import { getFechaActual } from '../../../resources/Helper';

const DEBUG_DASHBOARD = false;
const WOMPI_PAGO_SUSCRIPCION_URL = 'https://checkout.wompi.co/l/VPOS_bPA2UU';

const dashboardDebug = (...args) => {
    if (DEBUG_DASHBOARD) {
        console.log(...args);
    }
};

function Home() {
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [indicadores, setIndicadores] = useState({
        total_pacientes: 0,
        citas_hoy: 0,
        facturas_mes: 0,
        rips_pendientes: 0
    });
    const [notas, setNotas] = useState([]);
    const [noticias, setNoticias] = useState([]);
    const [showModalNota, setShowModalNota] = useState(false);
    const [nuevaNota, setNuevaNota] = useState({
        titulo: '',
        contenido: '',
        tipo: 'nota',
        color: 'info',
        fecha_recordatorio: ''
    });
    
    // 🆕 Estados para notificaciones de facturas
    const [notificacionesFacturas, setNotificacionesFacturas] = useState({
        facturas: [],
        estadisticas: {
            total_vencidas: 0,
            total_proximas_vencer: 0,
            total_pendientes_envio: 0,
            valor_total_vencidas: 0,
            valor_total_proximas: 0
        }
    });
    
    const [showModalRequisitosProfesional, setShowModalRequisitosProfesional] = useState(false);
    const [modalNuevaCitaState, setModalNuevaCitaState] = useState('hidden');

    // 🆕 Estado del cliente (para notificación de vencimiento)
    const [clienteInfo, setClienteInfo] = useState({
        estado: 0,
        fecha_vencimiento: null,
        dias_para_vencer: null
    });

    // 🆕 Estado para agenda favorita
    const [agendaFavorita, setAgendaFavorita] = useState({
        tiene_favorita: false,
        agenda_id: null,
        agenda_nombre: '',
        citas_hoy: 0,
        fecha_formateada: ''
    });

    // Obtener userdata del localStorage
    const userdata = JSON.parse(localStorage.getItem('userdata')) || { name: 'Usuario' };

    useEffect(() => {
        // Limpiar mensajes de toast del localStorage
        localStorage.removeItem('showtoast');
        localStorage.removeItem('toastmsg');
        localStorage.removeItem('toastdelay');
        
        cargarDashboard();
    }, []);

    useEffect(() => {
        if (location.state && location.state.profesionalRequisitos) {
            setShowModalRequisitosProfesional(true);
            history.replace({
                pathname: location.pathname,
                search: location.search,
                hash: location.hash,
                state: {}
            });
        }
    }, [location.state, location.pathname, location.search, location.hash, history]);

    const cargarDashboard = async () => {
        setLoading(true);
        
        dashboardDebug('=== INICIO CARGA DASHBOARD ===');
        dashboardDebug('User ID:', userdata.user_id);
        dashboardDebug('Client ID:', userdata.client_id);
        dashboardDebug('UserData completo:', userdata);
        dashboardDebug('Name:', userdata.name);
        dashboardDebug('Lastname:', userdata.lastname);
        dashboardDebug('User Name:', userdata.user_name);
        dashboardDebug('User Lastname:', userdata.user_lastname);
        
        // Cargar indicadores (con manejo de error independiente)
        try {
            dashboardDebug('Cargando indicadores...');
            // 🔒 Ya no necesitamos enviar uid - se obtiene del token JWT
            const respIndicadores = await axios.get('/dashboard/indicadores', {
                params: { fecha: getFechaActual() }
            });
            dashboardDebug('Indicadores recibidos:', respIndicadores.data);
            setIndicadores(respIndicadores.data);
        } catch (error) {
            console.error('Error al cargar indicadores:', error);
            console.error('Continuando con valores por defecto...');
            setIndicadores({
                total_pacientes: 0,
                citas_hoy: 0,
                facturas_mes: 0,
                rips_pendientes: 0
            });
        }

        // Cargar notas (independiente de los indicadores)
        try {
            const urlNotas = `/dashboard/notas?uid=${userdata.user_id}&limit=3&activos=1`;
            dashboardDebug('URL de notas:', urlNotas);
            dashboardDebug('Cargando notas...');
            
            const respNotas = await axios.get(urlNotas);
            dashboardDebug('Respuesta completa de notas:', respNotas);
            dashboardDebug('Notas recibidas:', respNotas.data);
            dashboardDebug('Cantidad de notas:', respNotas.data.length);
            dashboardDebug('Tipo de datos:', typeof respNotas.data);
            dashboardDebug('Es array?:', Array.isArray(respNotas.data));
            
            setNotas(respNotas.data);
            dashboardDebug('Notas guardadas en estado');
        } catch (error) {
            console.error('Error al cargar notas:', error);
            if (error.response) {
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
            }
            setNotas([]);
        }
        
        // Cargar noticias del sistema
        try {
            dashboardDebug('Cargando noticias del sistema...');
            const respNoticias = await axios.get('/noticias-activas');
            dashboardDebug('Noticias recibidas:', respNoticias.data);
            let dismissed = [];
            try {
                dismissed = JSON.parse(sessionStorage.getItem('noticias_dismissed') || '[]');
            } catch (e) {
                dismissed = [];
            }
            const lista = Array.isArray(respNoticias.data) ? respNoticias.data : [];
            setNoticias(lista.filter((n) => !dismissed.includes(n.id)));
        } catch (error) {
            console.error('Error al cargar noticias:', error);
            setNoticias([]);
        }
        
        // Notificaciones de facturas: API real (facturas a crédito con saldo y fecha de vencimiento)
        try {
            const respNotificaciones = await axios.get('/notificaciones/facturas-vencidas');
            const d = respNotificaciones.data || {};
            const est = d.estadisticas || {};
            setNotificacionesFacturas({
                facturas: d.facturas || [],
                estadisticas: {
                    total_vencidas: est.total_vencidas ?? 0,
                    total_proximas_vencer: est.total_proximas_vencer ?? 0,
                    total_pendientes_envio: est.total_pendientes_envio ?? 0,
                    valor_total_vencidas: est.valor_total_vencidas ?? 0,
                    valor_total_proximas: est.valor_total_proximas ?? 0
                }
            });
        } catch (error) {
            console.error('Error al cargar notificaciones de facturas:', error);
            setNotificacionesFacturas({
                facturas: [],
                estadisticas: {
                    total_vencidas: 0,
                    total_proximas_vencer: 0,
                    total_pendientes_envio: 0,
                    valor_total_vencidas: 0,
                    valor_total_proximas: 0
                }
            });
        }
        
        // 🆕 Cargar información del cliente (para notificación de vencimiento)
        try {
            dashboardDebug('Cargando información del cliente...');
            const respCliente = await axios.get('/dashboard/cliente-info');
            dashboardDebug('Info cliente recibida:', respCliente.data);
            setClienteInfo(respCliente.data);
        } catch (error) {
            console.error('Error al cargar info del cliente:', error);
            setClienteInfo({
                estado: 0,
                fecha_vencimiento: null,
                dias_para_vencer: null
            });
        }

        // 🆕 Cargar información de agenda favorita
        try {
            dashboardDebug('Cargando agenda favorita...');
            const respAgenda = await axios.get('/dashboard/agenda-favorita', {
                params: { fecha: getFechaActual() }
            });
            dashboardDebug('Agenda favorita recibida:', respAgenda.data);
            const dataAgenda = respAgenda.data || {};
            setAgendaFavorita({
                tiene_favorita: !!dataAgenda.tiene_favorita,
                agenda_id: dataAgenda.agenda_id || dataAgenda.profesional_id || null,
                agenda_nombre: dataAgenda.agenda_nombre || dataAgenda.profesional_nombre || '',
                citas_hoy: dataAgenda.citas_hoy || 0,
                fecha_formateada: dataAgenda.fecha_formateada || ''
            });

            // Sincronizar cache local para que /agenda abra la favorita actual.
            if (dataAgenda.tiene_favorita && (dataAgenda.agenda_id || dataAgenda.profesional_id)) {
                const agendaId = String(dataAgenda.agenda_id || dataAgenda.profesional_id);
                const ud = JSON.parse(localStorage.getItem('userdata') || '{}');
                ud.agenda_favorita = agendaId;
                localStorage.setItem('userdata', JSON.stringify(ud));
            }
        } catch (error) {
            console.error('Error al cargar agenda favorita:', error);
            setAgendaFavorita({
                tiene_favorita: false,
                agenda_id: null,
                agenda_nombre: '',
                citas_hoy: 0,
                fecha_formateada: ''
            });
        }
        
        setLoading(false);
        dashboardDebug('=== FIN CARGA DASHBOARD ===');
    };

    const crearNotaRapida = async (e) => {
        e.preventDefault();
        
        try {
            await axios.post(`/dashboard/notas?uid=${userdata.user_id}`, nuevaNota);
            setShowModalNota(false);
            setNuevaNota({
                titulo: '',
                contenido: '',
                tipo: 'nota',
                color: 'info',
                fecha_recordatorio: ''
            });
            window.dispatchEvent(new CustomEvent('smile-notas-updated'));
            cargarDashboard();
        } catch (error) {
            console.error('Error al crear nota:', error);
            alert('Error al crear la nota');
        }
    };

    const getColorClass = (color) => {
        const colores = {
            'info': 'bg-info',
            'warning': 'bg-warning',
            'danger': 'bg-danger',
            'success': 'bg-success',
            'primary': 'bg-primary'
        };
        return colores[color] || 'bg-info';
    };

    const getTipoIcon = (tipo) => {
        const iconos = {
            'nota': 'fas fa-sticky-note',
            'recordatorio': 'fas fa-bell',
            'importante': 'fas fa-exclamation-circle'
        };
        return iconos[tipo] || 'fas fa-sticky-note';
    };

    // Funciones helper para noticias del sistema
    const getNoticiaTone = (tipo) => {
        const tones = {
            info: { accent: '#17a2b8', bg: 'rgba(23, 162, 184, 0.07)', iconBg: 'rgba(23, 162, 184, 0.12)', iconColor: '#17a2b8' },
            secondary: { accent: '#6c757d', bg: 'rgba(108, 117, 125, 0.07)', iconBg: 'rgba(108, 117, 125, 0.12)', iconColor: '#6c757d' },
            light: { accent: '#adb5bd', bg: 'rgba(248, 249, 250, 0.95)', iconBg: 'rgba(173, 181, 189, 0.18)', iconColor: '#6c757d' },
            dark: { accent: '#343a40', bg: 'rgba(52, 58, 64, 0.06)', iconBg: 'rgba(52, 58, 64, 0.12)', iconColor: '#343a40' },
            warning: { accent: '#d4a017', bg: 'rgba(255, 193, 7, 0.09)', iconBg: 'rgba(255, 193, 7, 0.18)', iconColor: '#b8860b' },
            danger: { accent: '#dc3545', bg: 'rgba(220, 53, 69, 0.07)', iconBg: 'rgba(220, 53, 69, 0.12)', iconColor: '#c82333' },
            success: { accent: '#28a745', bg: 'rgba(40, 167, 69, 0.07)', iconBg: 'rgba(40, 167, 69, 0.12)', iconColor: '#218838' }
        };
        return tones[tipo] || tones.info;
    };

    const getNoticiaIcon = (noticia) => {
        if (noticia?.icono) return noticia.icono;
        const iconos = {
            info: 'fas fa-info-circle',
            secondary: 'fas fa-bullhorn',
            light: 'fas fa-bell',
            dark: 'fas fa-bullhorn',
            warning: 'fas fa-exclamation-triangle',
            danger: 'fas fa-exclamation-circle',
            success: 'fas fa-check-circle'
        };
        return iconos[noticia?.tipo] || 'fas fa-info-circle';
    };

    const formatearFechaNoticia = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const dismissNoticia = (id) => {
        const key = 'noticias_dismissed';
        let dismissed = [];
        try {
            dismissed = JSON.parse(sessionStorage.getItem(key) || '[]');
        } catch (e) {
            dismissed = [];
        }
        if (!dismissed.includes(id)) {
            dismissed.push(id);
            sessionStorage.setItem(key, JSON.stringify(dismissed));
        }
        setNoticias((prev) => prev.filter((n) => n.id !== id));
    };

    // 🆕 Funciones helper para notificaciones de facturas
    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor || 0)).toLocaleString('es-CO');
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const datePart = String(fecha).trim().split(/[T\s]/)[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
            const [y, m, d] = datePart.split('-').map(Number);
            return new Date(y, m - 1, d).toLocaleDateString('es-CO');
        }
        return new Date(fecha).toLocaleDateString('es-CO');
    };

    const linkPagoSuscripcion = (
        <a
            href={WOMPI_PAGO_SUSCRIPCION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="dash-kpi-link dash-suscripcion-pago-link"
            style={{ marginTop: 0 }}
        >
            Pague aquí
        </a>
    );

    const getColorNotificacion = (tipo) => {
        return tipo === 'vencida' ? 'danger' : 'warning';
    };

    const getIconoNotificacion = (tipo) => {
        return tipo === 'vencida' ? 'fas fa-exclamation-triangle' : 'fas fa-clock';
    };

    const verEstadoCuentaPaciente = (pacienteId) => {
        window.open(`/smile/#/estado-cuenta-paciente?id=${pacienteId}`, '_blank');
    };

    const formatearFechaLarga = (fecha = new Date()) => {
        try {
            return fecha.toLocaleDateString('es-CO', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (e) {
            return '';
        }
    };

    const irAgendaFavorita = () => {
        if (!agendaFavorita?.agenda_id) return;
        history.push(`/agenda?profesional=${agendaFavorita.agenda_id}`);
    };

    const abrirModalNuevaCita = () => {
        setModalNuevaCitaState('visible');
    };

    const cerrarModalNuevaCita = () => {
        setModalNuevaCitaState('hidden');
    };

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="home" />

            <div className="content-wrapper">
                <style>{`
                    .dash-wrap { padding-bottom: 10px; }
                    .dash-title { font-weight: 800; font-size: 1.78rem; margin: 0; color: #323a45; }
                    .dash-subtitle { font-size: 0.9rem; color: #8c8c8c; margin-top: 4px; text-transform: capitalize; }
                    .dash-top-actions .btn { border-radius: 10px !important; }

                    .dash-kpi-grid { margin-top: 8px; }
                    .dash-kpi {
                        background: #fff;
                        border: 1px solid rgba(0,0,0,0.05);
                        border-radius: 16px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.04);
                        padding: 18px 18px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        transition: transform .15s ease, box-shadow .15s ease;
                    }
                    .dash-kpi:hover { transform: translateY(-2px); box-shadow: 0 14px 40px rgba(0,0,0,0.06); }
                    .dash-kpi-label { font-size: 0.78rem; letter-spacing: .04rem; color: #9aa0a6; font-weight: 700; text-transform: uppercase; }
                    .dash-kpi-value { font-size: 1.68rem; font-weight: 800; color: #323a45; line-height: 1.1; margin-top: 2px; }
                    .dash-kpi-link { font-size: 0.84rem; color: #17a2b8; font-weight: 700; display: inline-flex; align-items: center; gap: 6px; margin-top: 8px; text-decoration: none; }
                    .dash-kpi-link:hover { text-decoration: underline; color: #138496; }
                    /* AdminLTE pone .alert a { color: #fff } — forzar azul legible en aviso de suscripción */
                    .alert .dash-suscripcion-pago-link,
                    .alert .dash-suscripcion-pago-link:visited {
                        color: #17a2b8 !important;
                        font-weight: 700 !important;
                        text-decoration: none !important;
                    }
                    .alert .dash-suscripcion-pago-link:hover {
                        color: #138496 !important;
                        text-decoration: underline !important;
                    }
                    .dash-kpi-icon {
                        width: 44px; height: 44px;
                        border-radius: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                        flex: 0 0 auto;
                    }

                    .dash-banner {
                        background: linear-gradient(135deg, rgba(255,77,79,0.08) 0%, rgba(255,193,7,0.08) 100%);
                        border: 1px solid rgba(255,77,79,0.16);
                        border-radius: 16px;
                        padding: 14px 16px;
                    }
                    .dash-banner-title { font-weight: 800; color: #c53030; font-size: 1.02rem; margin: 0; }
                    .dash-banner-sub { color: #8c8c8c; font-size: 0.84rem; margin-top: 2px; }
                    .dash-banner-actions .btn { border-radius: 10px !important; }
                    .fav-agenda-banner {
                        background: #ffffff;
                        border: 1px solid rgba(0,0,0,0.05);
                        border-left: 4px solid #17a2b8;
                        border-radius: 16px;
                        padding: 16px 18px;
                        color: #323a45;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.04);
                        position: relative;
                        overflow: hidden;
                        gap: 12px;
                    }
                    .fav-agenda-title {
                        font-weight: 800;
                        margin: 0 0 6px 0;
                        color: #323a45;
                        font-size: 1.12rem;
                    }
                    .fav-agenda-sub {
                        margin: 0;
                        color: #5f6b77;
                        font-size: 0.94rem;
                    }
                    .fav-agenda-pattern {
                        position: absolute;
                        right: -16px;
                        bottom: -24px;
                        font-size: 120px;
                        opacity: 0.05;
                        transform: rotate(-15deg);
                        z-index: 1;
                        color: #17a2b8;
                    }

                    .dash-card {
                        background: #fff;
                        border: 1px solid rgba(0,0,0,0.05);
                        border-radius: 16px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.04);
                        overflow: hidden;
                    }
                    .dash-card-header {
                        padding: 14px 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-bottom: 1px solid rgba(0,0,0,0.04);
                        background: #fff;
                    }
                    .dash-card-title { display: flex; align-items: center; gap: 10px; font-weight: 800; color: #323a45; margin: 0; font-size: 1.02rem; }
                    .dash-card-title .title-icon {
                        width: 30px; height: 30px; border-radius: 10px; display: flex; align-items: center; justify-content: center;
                        background: rgba(23,162,184,0.10); color: #17a2b8;
                    }
                    .dash-card-body { padding: 14px 16px; }

                    .note-item { display: flex; gap: 12px; padding: 10px 0; border-bottom: 1px solid rgba(0,0,0,0.04); }
                    .note-item:last-child { border-bottom: none; }
                    .note-dot { width: 8px; height: 8px; border-radius: 999px; margin-top: 6px; flex: 0 0 auto; }
                    .note-title { font-weight: 800; color: #323a45; font-size: 0.92rem; margin: 0; }
                    .note-desc { color: #8c8c8c; font-size: 0.84rem; margin: 2px 0 0 0; line-height: 1.4; }
                    .note-meta { color: #b0b0b0; font-size: 0.76rem; margin-top: 6px; display: inline-flex; align-items: center; gap: 6px; }

                    .dash-noticias { display: flex; flex-direction: column; gap: 10px; }
                    .dash-noticia {
                        display: flex;
                        gap: 14px;
                        align-items: flex-start;
                        border-radius: 14px;
                        border: 1px solid rgba(0,0,0,0.05);
                        border-left-width: 4px;
                        padding: 14px 16px;
                        box-shadow: 0 8px 24px rgba(0,0,0,0.035);
                        position: relative;
                        animation: dashNoticiaIn .28s ease;
                    }
                    @keyframes dashNoticiaIn {
                        from { opacity: 0; transform: translateY(-6px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .dash-noticia-icon {
                        width: 40px; height: 40px;
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        flex: 0 0 auto;
                    }
                    .dash-noticia-body { flex: 1; min-width: 0; padding-right: 28px; }
                    .dash-noticia-title {
                        margin: 0 0 4px 0;
                        font-size: 0.98rem;
                        font-weight: 800;
                        color: #323a45;
                        line-height: 1.3;
                    }
                    .dash-noticia-text {
                        margin: 0;
                        font-size: 0.88rem;
                        color: #5f6b77;
                        line-height: 1.45;
                        white-space: pre-wrap;
                    }
                    .dash-noticia-meta {
                        margin-top: 8px;
                        font-size: 0.76rem;
                        color: #9aa0a6;
                        display: inline-flex;
                        align-items: center;
                        gap: 6px;
                    }
                    .dash-noticia-close {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        width: 28px;
                        height: 28px;
                        border: none;
                        border-radius: 8px;
                        background: rgba(0,0,0,0.04);
                        color: #8c8c8c;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        transition: background .15s ease, color .15s ease;
                    }
                    .dash-noticia-close:hover {
                        background: rgba(0,0,0,0.08);
                        color: #323a45;
                    }

                    .quick-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
                    @media (max-width: 992px) { .quick-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
                    .quick-card {
                        border: 1px solid rgba(0,0,0,0.05);
                        border-radius: 16px;
                        padding: 14px 12px;
                        background: #fff;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        transition: transform .15s ease, box-shadow .15s ease;
                        text-decoration: none;
                    }
                    .quick-card:hover { transform: translateY(-2px); box-shadow: 0 12px 30px rgba(0,0,0,0.06); text-decoration: none; }
                    .quick-ico {
                        width: 44px; height: 44px; border-radius: 14px;
                        display: flex; align-items: center; justify-content: center;
                        font-size: 18px;
                        background: rgba(23,162,184,0.12);
                        color: #17a2b8;
                    }
                    .quick-grid .quick-card:nth-child(odd) .quick-ico {
                        background: rgba(23,162,184,0.12);
                        color: #17a2b8;
                    }
                    .quick-grid .quick-card:nth-child(even) .quick-ico {
                        background: rgba(52,58,64,0.12);
                        color: #343a40;
                    }
                    .quick-title { font-weight: 800; color: #323a45; font-size: 0.9rem; margin: 0; text-align: center; }
                    .quick-sub { color: #8c8c8c; font-size: 0.76rem; margin: -2px 0 0 0; text-align: center; }

                    @media (max-width: 1200px) {
                        .dash-title { font-size: 1.62rem; }
                        .dash-subtitle { font-size: 0.86rem; }
                        .dash-kpi-value { font-size: 1.56rem; }
                        .dash-kpi-link { font-size: 0.8rem; }
                    }
                `}</style>
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <div className="dash-wrap">
                                    <div className="dash-title">
                                        Bienvenido, {userdata?.name || userdata?.user_name || 'Usuario'} {userdata?.lastname || userdata?.user_lastname || ''}
                                    </div>
                                    <div className="dash-subtitle">{formatearFechaLarga()}</div>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="float-right dash-top-actions">
                                    <Link to="/busqueda-citas" className="btn btn-primary btn-sm mr-2">
                                        <i className="fas fa-search"></i> Buscar Citas
                                    </Link>
                                    <Link to="/control-asistencia" className="btn btn-primary btn-sm">
                                        <i className="far fa-calendar-alt"></i> Control Asistencia
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* 🆕 BANNER DE AGENDA FAVORITA */}
                        {agendaFavorita.tiene_favorita && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="fav-agenda-banner">
                                        <div style={{ position: 'relative', zIndex: 2 }}>
                                            <h4 className="fav-agenda-title">
                                                En tu Agenda
                                            </h4>
                                            <p className="fav-agenda-sub">
                                                Tienes <strong>{agendaFavorita.citas_hoy} citas</strong> Programadas para hoy, {agendaFavorita.fecha_formateada}.
                                            </p>
                                        </div>
                                        <div style={{ position: 'relative', zIndex: 2, display: 'flex', gap: '8px' }}>
                                            <button
                                                type="button"
                                                onClick={irAgendaFavorita}
                                                className="btn btn-sm btn-outline-info"
                                                style={{ 
                                                    borderRadius: '12px', 
                                                    padding: '8px 16px', 
                                                    fontWeight: 700
                                                }}
                                            >
                                                <i className="far fa-calendar-check mr-2"></i> Ir a Agenda
                                            </button>
                                        </div>
                                        {/* Elemento decorativo */}
                                        <i className="far fa-calendar-alt fav-agenda-pattern"></i>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        {loading ? (
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                            </div>
                        ) : (
                            <>
                                {/* INDICADORES KPI */}
                                <div className="row dash-kpi-grid">
                                    <div className="col-lg-3 col-md-6 mb-3">
                                        <div className="dash-kpi">
                                            <div>
                                                <div className="dash-kpi-label">Pacientes registrados</div>
                                                <div className="dash-kpi-value">{indicadores.total_pacientes}</div>
                                                <Link to="/pacientes" className="dash-kpi-link">Ver Pacientes <i className="fas fa-arrow-right"></i></Link>
                                            </div>
                                            <div className="dash-kpi-icon" style={{ background: 'rgba(23, 162, 184, 0.10)', color: '#17a2b8' }}>
                                                <i className="fas fa-user-plus"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-3">
                                        <div className="dash-kpi">
                                            <div>
                                                <div className="dash-kpi-label">Citas de hoy</div>
                                                <div className="dash-kpi-value">{indicadores.citas_hoy}</div>
                                                <Link to="/lista-citas" className="dash-kpi-link">Ver Citas <i className="fas fa-arrow-right"></i></Link>
                                            </div>
                                            <div className="dash-kpi-icon" style={{ background: 'rgba(255, 193, 7, 0.22)', color: '#c29200' }}>
                                                <i className="far fa-calendar-alt"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-3">
                                        <div className="dash-kpi">
                                            <div>
                                                <div className="dash-kpi-label">Facturas del mes</div>
                                                <div className="dash-kpi-value">{indicadores.facturas_mes}</div>
                                                <Link to="/listado-facturas" className="dash-kpi-link">Ver Facturas <i className="fas fa-arrow-right"></i></Link>
                                            </div>
                                            <div className="dash-kpi-icon" style={{ background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-file-invoice-dollar"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-3">
                                        <div className="dash-kpi">
                                            <div>
                                                <div className="dash-kpi-label">RIPS registrados</div>
                                                <div className="dash-kpi-value">{indicadores.rips_pendientes}</div>
                                                <Link to="/listado-rips" className="dash-kpi-link">Ver RIPS <i className="fas fa-arrow-right"></i></Link>
                                            </div>
                                            <div className="dash-kpi-icon" style={{ background: 'rgba(52, 58, 64, 0.12)', color: '#343a40' }}>
                                                <i className="fas fa-file-medical"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* NOTICIAS DEL SISTEMA */}
                                {noticias.length > 0 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div className="dash-noticias">
                                                {noticias.map((noticia) => {
                                                    const tone = getNoticiaTone(noticia.tipo);
                                                    return (
                                                        <div
                                                            key={noticia.id}
                                                            className="dash-noticia"
                                                            role="status"
                                                            style={{
                                                                background: tone.bg,
                                                                borderLeftColor: tone.accent
                                                            }}
                                                        >
                                                            <div
                                                                className="dash-noticia-icon"
                                                                style={{ background: tone.iconBg, color: tone.iconColor }}
                                                            >
                                                                <i className={getNoticiaIcon(noticia)}></i>
                                                            </div>
                                                            <div className="dash-noticia-body">
                                                                <h5 className="dash-noticia-title">{noticia.titulo}</h5>
                                                                <p className="dash-noticia-text">{noticia.contenido}</p>
                                                                {noticia.fecha_fin && (
                                                                    <span className="dash-noticia-meta">
                                                                        <i className="far fa-calendar-alt"></i>
                                                                        Hasta {formatearFechaNoticia(noticia.fecha_fin)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="dash-noticia-close"
                                                                aria-label="Cerrar noticia"
                                                                onClick={() => dismissNoticia(noticia.id)}
                                                            >
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* 🆕 NOTIFICACIÓN DE VENCIMIENTO DEL CLIENTE */}
                                {clienteInfo.estado === 3 && clienteInfo.dias_para_vencer !== null && clienteInfo.dias_para_vencer <= 10 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div
                                                className="alert alert-dismissible fade show border-0 shadow-sm"
                                                role="alert"
                                                style={
                                                    clienteInfo.dias_para_vencer < 0
                                                        ? {
                                                            backgroundColor: '#fdf0ee',
                                                            color: '#5c3a38',
                                                            borderLeft: '4px solid #d9a8a3',
                                                        }
                                                        : {
                                                            backgroundColor: '#fff9eb',
                                                            color: '#5c4d2e',
                                                            borderLeft: '4px solid #e8d48b',
                                                        }
                                                }
                                            >
                                                <h5 className="mb-2" style={{ fontSize: '1.05rem' }}>
                                                    <i className={`fas ${clienteInfo.dias_para_vencer < 0 ? 'fa-calendar-times' : 'fa-exclamation-triangle'} mr-2`}></i>
                                                    {clienteInfo.dias_para_vencer < 0
                                                        ? 'Su suscripción está vencida'
                                                        : 'Su suscripción está próxima a vencer'}
                                                </h5>
                                                <p className="mb-0" style={{ fontSize: '0.95rem' }}>
                                                    {clienteInfo.dias_para_vencer < 0 ? (
                                                        <>
                                                            Su plan venció el <strong>{formatearFecha(clienteInfo.fecha_vencimiento)}</strong>.
                                                            {' '}Realice su pago aquí: {linkPagoSuscripcion}.
                                                        </>
                                                    ) : (
                                                        <>
                                                            Su plan vence el <strong>{formatearFecha(clienteInfo.fecha_vencimiento)}</strong>
                                                            {clienteInfo.dias_para_vencer === 0
                                                                ? ' (vence hoy)'
                                                                : ` (${clienteInfo.dias_para_vencer} día${clienteInfo.dias_para_vencer === 1 ? '' : 's'} restantes)`}
                                                            . Recuerde realizar el pago de su suscripción. {linkPagoSuscripcion}.
                                                        </>
                                                    )}
                                                </p>
                                                <button type="button" className="close" data-dismiss="alert" aria-label="Cerrar">
                                                    <span>&times;</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* 🆕 NOTIFICACIONES DE FACTURACIÓN */}
                                {(notificacionesFacturas.estadisticas.total_vencidas > 0 || notificacionesFacturas.estadisticas.total_pendientes_envio > 0) && (
                                    <div className="row mb-3">
                                        {/* Facturas Vencidas */}
                                        {notificacionesFacturas.estadisticas.total_vencidas > 0 && (
                                            <div className="col-12 mb-2">
                                                <div className="dash-banner d-flex justify-content-between align-items-center flex-wrap">
                                                    <div>
                                                        <div className="dash-banner-title">
                                                            <i className="fas fa-exclamation-triangle mr-2"></i>
                                                            {notificacionesFacturas.estadisticas.total_vencidas} Facturas vencidas
                                                        </div>
                                                        <div className="dash-banner-sub">Saldo pendiente: <strong>{formatearValor(notificacionesFacturas.estadisticas.valor_total_vencidas)}</strong></div>
                                                    </div>
                                                    <div className="dash-banner-actions d-flex align-items-center" style={{ gap: '8px' }}>
                                                        <Link to="/listado-facturas?filtro=vencidas" className="btn btn-outline-danger btn-sm">
                                                            Ver Facturas <i className="fas fa-arrow-right ml-1"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Facturas Pendientes de Envío a DIAN */}
                                        {notificacionesFacturas.estadisticas.total_pendientes_envio > 0 && (
                                            <div className="col-md-12">
                                                <div className="card card-outline card-primary">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h5 className="text-primary mb-1">
                                                                    <i className="fas fa-file-invoice"></i> Pendientes DIAN
                                                                </h5>
                                                                <h3 className="mb-0">{notificacionesFacturas.estadisticas.total_pendientes_envio}</h3>
                                                                <small className="text-muted">
                                                                    Borradores y con errores
                                                                </small>
                                                            </div>
                                                            <Link to="/listado-facturas?filtro=pendientes" className="btn btn-outline-primary">
                                                                <i className="fas fa-list"></i> Ver
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* NOTAS Y ACTIVIDAD RECIENTE */}
                                <div className="row">
                                    {/* NOTAS Y RECORDATORIOS */}
                                    <div className="col-md-6">
                                        <div className="dash-card">
                                            <div className="dash-card-header">
                                                <h3 className="dash-card-title">
                                                    <span className="title-icon"><i className="fas fa-sticky-note"></i></span>
                                                    Notas y Recordatorios
                                                </h3>
                                                <button className="btn btn-primary btn-sm" onClick={() => setShowModalNota(true)}>
                                                    <i className="fas fa-plus mr-1"></i> Nueva Nota
                                                </button>
                                            </div>
                                            <div className="dash-card-body">
                                                {notas.length === 0 ? (
                                                    <p className="text-muted mb-0">No hay notas pendientes.<br /><small>Las notas completadas se ocultan del dashboard.</small></p>
                                                ) : (
                                                    <>
                                                        {notas.map(nota => {
                                                            const dot =
                                                                nota.color === 'danger' ? '#dc3545' :
                                                                nota.color === 'warning' ? '#faad14' :
                                                                nota.color === 'success' ? '#28a745' :
                                                                '#17a2b8';
                                                            return (
                                                                <div className="note-item" key={nota.id}>
                                                                    <span className="note-dot" style={{ background: dot }}></span>
                                                                    <div style={{ flex: 1 }}>
                                                                        <p className="note-title">{nota.titulo}</p>
                                                                        <p className="note-desc">{nota.contenido}</p>
                                                                        {nota.fecha_recordatorio && (
                                                                            <span className="note-meta">
                                                                                <i className="fas fa-calendar"></i> {nota.fecha_recordatorio}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ color: '#c0c0c0' }}>
                                                                        <i className={getTipoIcon(nota.tipo)}></i>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                <div className="mt-3">
                                                    <Link to="/administrar-notas" className="dash-kpi-link">Ver todas las notas <i className="fas fa-arrow-right"></i></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ACCESOS RÁPIDOS */}
                                    <div className="col-md-6">
                                        <div className="dash-card">
                                            <div className="dash-card-header">
                                                <h3 className="dash-card-title">
                                                    <span className="title-icon">
                                                        <i className="fas fa-bolt"></i>
                                                    </span>
                                                    Accesos Rápidos
                                                </h3>
                                            </div>
                                            <div className="dash-card-body">
                                                <div className="quick-grid">
                                                    <button type="button" className="quick-card border-0" onClick={abrirModalNuevaCita}>
                                                        <div className="quick-ico"><i className="fas fa-calendar-plus"></i></div>
                                                        <p className="quick-title">Agendar Cita</p>
                                                        <p className="quick-sub">Nueva Cita Médica</p>
                                                    </button>
                                                    <Link to="/crear-factura" className="quick-card">
                                                        <div className="quick-ico"><i className="fas fa-file-invoice"></i></div>
                                                        <p className="quick-title">Nueva Factura</p>
                                                        <p className="quick-sub">Crear Facturación</p>
                                                    </Link>
                                                    <Link to="/pacientes" className="quick-card">
                                                        <div className="quick-ico"><i className="fas fa-user-plus"></i></div>
                                                        <p className="quick-title">Nuevo Paciente</p>
                                                        <p className="quick-sub">Registrar Paciente</p>
                                                    </Link>
                                                    <Link to="/listado-rips" className="quick-card">
                                                        <div className="quick-ico"><i className="fas fa-file-medical"></i></div>
                                                        <p className="quick-title">Consultar RIPS</p>
                                                        <p className="quick-sub">Registros Clínicos</p>
                                                    </Link>
                                                    <Link to="/crear-documento-soporte" className="quick-card">
                                                        <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                                        <p className="quick-title">Doc. Soporte</p>
                                                        <p className="quick-sub">Documento electrónico</p>
                                                    </Link>
                                                    <Link to="/indicadores" className="quick-card">
                                                        <div className="quick-ico"><i className="fas fa-chart-line"></i></div>
                                                        <p className="quick-title">Indicadores</p>
                                                        <p className="quick-sub">Métricas y Reportes</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            </div>

            {/* Modal para crear nota rápida */}
            <div className={`modal fade ${showModalNota ? 'show' : ''}`} 
                 style={{ display: showModalNota ? 'block' : 'none' }}
                 tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={crearNotaRapida}>
                            <div className="modal-header">
                                <h4 className="modal-title">Nueva Nota Rápida</h4>
                                <button type="button" className="close" onClick={() => setShowModalNota(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Título *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={nuevaNota.titulo}
                                        onChange={(e) => setNuevaNota({...nuevaNota, titulo: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Contenido *</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={nuevaNota.contenido}
                                        onChange={(e) => setNuevaNota({...nuevaNota, contenido: e.target.value})}
                                        required
                                    ></textarea>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Tipo</label>
                                            <select
                                                className="form-control"
                                                value={nuevaNota.tipo}
                                                onChange={(e) => setNuevaNota({...nuevaNota, tipo: e.target.value})}
                                            >
                                                <option value="nota">Nota</option>
                                                <option value="recordatorio">Recordatorio</option>
                                                <option value="importante">Importante</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Color</label>
                                            <select
                                                className="form-control"
                                                value={nuevaNota.color}
                                                onChange={(e) => setNuevaNota({...nuevaNota, color: e.target.value})}
                                            >
                                                <option value="info">Azul</option>
                                                <option value="warning">Amarillo</option>
                                                <option value="danger">Rojo</option>
                                                <option value="success">Verde</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {nuevaNota.tipo === 'recordatorio' && (
                                    <div className="form-group">
                                        <label>Fecha de Recordatorio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={nuevaNota.fecha_recordatorio}
                                            onChange={(e) => setNuevaNota({...nuevaNota, fecha_recordatorio: e.target.value})}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalNota(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Crear Nota
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showModalNota && <div className="modal-backdrop fade show"></div>}

            <div
                className={`modal fade ${showModalRequisitosProfesional ? 'show' : ''}`}
                style={{ display: showModalRequisitosProfesional ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modalRequisitosProfesionalTitulo"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="modalRequisitosProfesionalTitulo">
                                Datos profesionales incompletos
                            </h4>
                            <button
                                type="button"
                                className="close"
                                aria-label="Cerrar"
                                onClick={() => setShowModalRequisitosProfesional(false)}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mb-0">
                                Para usar la atención de pacientes y las funciones clínicas asociadas, debe completar
                                en <strong>Mi perfil</strong> su <strong>firma</strong> y su <strong>registro médico</strong>.
                                Sin estos datos el sistema no permite ingresar a esa sección.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setShowModalRequisitosProfesional(false)}
                            >
                                Entendido
                            </button>
                            <Link to="/perfil" className="btn btn-primary" onClick={() => setShowModalRequisitosProfesional(false)}>
                                Ir a Mi perfil
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {showModalRequisitosProfesional && <div className="modal-backdrop fade show"></div>}

            <FormNuevaCita
                modalState={modalNuevaCitaState}
                closeModal={cerrarModalNuevaCita}
                fecha={getFechaActual()}
                profesionalAsignado={agendaFavorita?.agenda_id || ''}
                usuarioAsigna={userdata?.user_id || ''}
                nombreUsuarioAsigna={`${userdata?.name || userdata?.user_name || ''} ${userdata?.lastname || userdata?.user_lastname || ''}`.trim()}
                reloadCitasAgenda={() => {}}
            />

            <Footer showToast={false} />
        </div>
    );
}

export default Home;
